  /* eslint-disable */

import homePage_msg from '@/locales/HomePage/HomePage.json' 
import program_msg from '@/locales/Program/Program.json'
import registration_msg from '@/locales/Registration/Registration.json'
import interestedPartner_msg from '@/locales/InterestedPartners/InterestedPartner.json'


import { createI18n } from 'vue-i18n'

const sources = [homePage_msg, program_msg, interestedPartner_msg, registration_msg ];



var results = sources.reduce(function (results, org, index) { 
    if (Object.keys(org)[0] === 'en') {
        (results['en'] = results['en'] || []).push(org.en);
    }
    if (Object.keys(org)[1] === 'ar') {
        (results['ar'] = results['ar'] || []).push(org.ar);
    } 
    return results;
}, {}); 
let enMsg = results.en.reduce(function (result, current) {
    return Object.assign(result, current);
}, {});
let arMsg = results.ar.reduce(function (result, current) {
    return Object.assign(result, current);
}, {}); 
console.log(enMsg)
const i18n = createI18n({
    locale: localStorage.getItem('Public_lang') || 'ar-sa',
    messages: {
        'en-us': enMsg,
        'ar-sa': arMsg
    }
});

export default i18n;